import AdminOrderDetail from './AdminOrderDetail';

export default AdminOrderDetail; 